<template>
  <el-dialog :visible="true" width="95%" top="2vh" :before-close="close">
    <div slot="title" style="text-align: center">
      <span class="fz18 fw500" style="font-weight: bolder">申请开票</span>
    </div>
    <!--    -->
    <div v-show="+step === 0">
      <!--      <base-table ref="baseTable" :tableColumn="tableColumns" :data="tableData" height="60vh" rowKey="dingdanbianhao" @selection-change="select=>tableSelection=select"/>-->
      <table-render
        v-show="+step === 0"
        ref="tableRender"
        height="55vh"
        rowKey="csoCustomOrderId"
        :config="tableConfig"
        :beforeInitPage="beforeInitPage0"
        @selection-change="e => (tableSelectionStep0 = e)"
      >
        <template slot="batchAction" slot-scope="scope">
          <table>
            <tbody>
              <tr>
                <td class="pr30" v-if="tableSelectionStep0.length">
                  <el-button type="text" @click="clearTableSelection">
                    清空
                  </el-button>
                </td>
                <td class="pr30">
                  共
                  <span class="">{{ tableSelectionStep0.length }}</span>
                  项
                </td>
                <td class="pr30">
                  已选人数：
                  <span class="">{{ yixuanrenshu }}</span>
                  人
                </td>
                <td class="pr30">
                  价税合计：
                  <span class="">
                    {{ yixuanrenshuPriceTotal | moneyFixed }}
                  </span>
                </td>
                <td class="pr30">
                  最大开票金额：
                  <span class="">
                    {{
                      scope &&
                        scope.tableResp.maximumAmountInvoiced | moneyFixed
                    }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </table-render>
    </div>
    <!--    -->

    <!--开票信息start-->
    <div v-if="+step === 1">
      <el-row :gutter="10">
        <div class="app-detail-item-title pb16" style="width:100%">
          开票信息
        </div>
        <el-col
          class="mb16 app-form-item"
          :xs="12"
          :sm="12"
          :md="12"
          :lg="8"
          :xl="8"
        >
          <div class="app-form-label">开票方式 ：</div>
          <el-radio
            class="app-form-input"
            v-model="formValues.openType"
            label="1"
          >
            纸制发票
          </el-radio>
        </el-col>

        <div class="app-detail-item-title pb16" style="width:100%">
          发票邮寄信息
        </div>
        <el-col>
          <el-col
            class="mb16 app-form-item"
            :xs="12"
            :sm="12"
            :md="12"
            :lg="8"
            :xl="8"
          >
            <div class="app-form-label">收件地址 ：</div>
            <el-select
              size="small"
              v-model="formValues.addressId"
              @change="e => addressChange(e, formOptions.addressList)"
              placeholder="选择收件地址"
              v-if="formOptions.addressList"
            >
              <el-option
                v-for="item in formOptions.addressList"
                :key="item.id"
                :label="item.addressName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-col>
        </el-col>

        <el-col
          class="mb16 app-form-item"
          :xs="12"
          :sm="12"
          :md="12"
          :lg="8"
          :xl="8"
        >
          <div class="app-form-label">收件人 ：</div>
          <el-input
            class="app-form-input"
            size="small"
            :value="formAddressSelected.receiptFullName"
            disabled
          ></el-input>
        </el-col>
        <el-col
          class="mb16 app-form-item"
          :xs="12"
          :sm="12"
          :md="12"
          :lg="8"
          :xl="8"
        >
          <div class="app-form-label">联系方式 ：</div>
          <el-input
            class="app-form-input"
            size="small"
            :value="formAddressSelected.receiptPhone"
            disabled
          ></el-input>
        </el-col>
        <el-col
          class="mb16 app-form-item"
          :xs="12"
          :sm="12"
          :md="12"
          :lg="8"
          :xl="8"
        >
          <div class="app-form-label">发票邮寄地址 ：</div>
          <el-input
            class="app-form-input"
            size="small"
            :value="formAddressSelected.receiptAddress"
            placeholder="选择发票邮寄地址"
            disabled
          ></el-input>
        </el-col>
        <div class="app-detail-item-title pb16" style="width:100%">
          默认开票种类
        </div>
        <el-col
          class="mb16 app-form-item"
          :xs="12"
          :sm="12"
          :md="12"
          :lg="8"
          :xl="8"
        >
          <div class="app-form-label">发票类别 ：</div>
          <el-select
            class="app-form-input"
            size="small"
            v-model="formValues._invoiceCategoryId"
          >
            <el-option
              v-for="category in formOptions.defaultInvoicingTypeList"
              :key="category.id"
              :label="category.label"
              :value="category.id"
            ></el-option>
          </el-select>
        </el-col>
        <el-col
          class="mb16 app-form-item"
          :xs="12"
          :sm="12"
          :md="12"
          :lg="8"
          :xl="8"
        >
          <div class="app-form-label">发票类目 ：</div>

          <el-select
            class="app-form-input"
            size="small"
            v-model="formValues._invoiceItemId"
            :disabled="!formOptions._invoiceItems.length"
            :placeholder="
              formOptions._invoiceItems.length
                ? ''
                : '当前发票类别下 没有发票类目'
            "
          >
            <el-option
              v-for="categoryChild in formOptions._invoiceItems"
              :key="categoryChild.id"
              :label="categoryChild.itemName"
              :value="categoryChild.id"
            ></el-option>
          </el-select>
        </el-col>

        <!--        开票内容 start-->
        <div class="app-detail-item-title pb16" style="width:100%">
          开票内容
        </div>
        <apply-content
          ref="conentList"
          v-if="+step === 1"
          v-bind="billListQuery"
          :formOptions="{ ...formOptions }"
        />
        <!--        开票内容 ended-->
      </el-row>
      <table>
        <tbody>
          <tr>
            <td class="pr30" v-if="tableSelectionStep0.length">
              <!--            <el-button type="text" @click="clearTableSelection">清空</el-button>-->
            </td>
            <td class="pr30">
              共
              <span class="">{{ tableSelectionStep0.length }}</span>
              项
            </td>
            <td class="pr30">
              已选人数：
              <span class="">{{ yixuanrenshu }}</span>
              人
            </td>
            <td class="pr30">
              价税合计：
              <span class="">{{ yixuanrenshuPriceTotal | moneyFixed }}</span>
            </td>
            <td class="pr30">
              最大开票金额：
              <span class="">
                {{
                  $refs.tableRender &&
                    $refs.tableRender.tableResp.maximumAmountInvoiced
                      | moneyFixed
                }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>

      <el-form style="display: none" ref="form" :model="formValues">
        <el-form-item label="开票方式">
          <el-input v-model="formValues.user" placeholder="开票方式"></el-input>
        </el-form-item>
        <el-form-item label="收件地址">
          <el-select
            v-model="formValues.user"
            placeholder="选择收件地址"
          ></el-select>
        </el-form-item>
        <el-form-item label="收件人">
          <el-select
            v-model="formValues.user"
            placeholder="选择收件人"
          ></el-select>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-select
            v-model="formValues.user"
            placeholder="选择联系方式"
          ></el-select>
        </el-form-item>
        <el-form-item label="发票邮寄地址">
          <el-select
            v-model="formValues.user"
            placeholder="选择发票邮寄地址"
          ></el-select>
        </el-form-item>
      </el-form>
    </div>

    <!--开票信息ended    -->

    <span slot="footer" class="dialog-footer">
      <el-button
        size="small"
        type="primary"
        v-if="step > 0"
        @click="Math.max(0, step--)"
      >
        上一步
      </el-button>
      <el-button
        size="small"
        type="primary"
        v-if="step < stepMax"
        :disabled="!canSubmit"
        @click="Math.min(stepMax, step++)"
      >
        下一步
      </el-button>
      <!--      <el-button size="small" type="primary" v-if="step===stepMax" :disabled="!canSubmit1" plain @click="toOpen(billListQuery)">确认开票</el-button>-->
      <el-button
        size="small"
        type="primary"
        v-if="step === stepMax"
        plain
        @click="toOpen()"
      >
        确认开票
      </el-button>
      <el-button size="small" @click="close">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { main } from './ApplyForCommission.config';
import tableRender from '@C/tableRender/index';
import { invoice } from '@/api/ajax';
import createExtend from '@C/createExtend';
// import ContentOfMakeOutAnInvoice from './ApplyForCommissionContent';
import ApplyForCommissionSubmitRespond from '@/page/bill/child/invoiceTable/ApplyForCommissionSubmitRespond';
import ApplyForCommissionContent from '@/page/bill/child/invoiceTable/ApplyForCommissionContent';
import { flat } from '@/tools/index';

export default {
  name: 'ApplyForInvoicing',
  components: {
    ApplyContent: ApplyForCommissionContent,
    tableRender
  },
  cname: '申请委托代开发票',
  provide() {
    return {
      indexPage: this
    };
  },
  data() {
    return {
      step: 0,
      stepMax: 1,
      tableConfig: main,
      tableSelectionStep0: [],

      // 选择收件地址对象
      formAddressSelected: {},

      formValues: {
        openType: '1', //开票方式 fk pm
        addressId: '', //
        _invoiceCategoryId: '',
        _invoiceItemId: ''
      },
      formOptions: {
        addressList: [],
        defaultInvoicingTypeList: [],
        _invoiceItems: []
      },
      selectedPersonForOrderNo: {} // 用于存储申请开票已选人，初始列表时匹配赋值
    };
  },
  computed: {
    canSubmit1() {
      //TODO
      return this.formOptions._invoiceItems.length;
    },
    billListQuery: {
      get: function() {
        const taxationIdList = this.tableSelectionStep0.map(i => {
          return i.$selectedPerson.map(i => i.taxationId);
        });

        const invoiceCategory = +this.formValues._invoiceCategoryId;
        const invoiceItemId = +this.formValues._invoiceItemId;
        const invoiceItemName = this.formOptions._invoiceItems.find(
          i => i.id === this.formValues._invoiceItemId
        );
        const itemName = invoiceItemName ? invoiceItemName.itemName : '';
        return {
          // taxationIdList:taxationIdList.join('') ,  // []  存放上一页的id数组
          taxationIdList: flat(taxationIdList), // []  存放上一页的id数组 人员id
          invoiceCategory: invoiceCategory, // 一级类目 int类型  1或者2
          invoiceItemId: invoiceItemId, //二级类目的id
          itemName: itemName //二级类目的名字
        };
      }
    },
    yixuanrenshu() {
      let list = this.tableSelectionStep0.map(i => i.$selectedPerson.length);
      if (!list.length) return 0;
      return list.reduce((a, b) => {
        return a + b;
      });
    },
    yixuanrenshuPriceTotal() {
      let list = this.tableSelectionStep0.map(i => i.$clientCountPrice);
      if (!list.length) return 0;
      return list.reduce((a, b) => {
        return a + b;
      });
    },
    canSubmit() {
      return this.tableSelectionStep0.length > 0;
    }
  },
  watch: {
    // 选择发票类别时 联动 发票类目
    'formValues._invoiceCategoryId': {
      handler: function(v) {
        if (!v) {
          return;
        }
        this.formOptions._invoiceItems =
          this.formOptions.defaultInvoicingTypeList.find(i => +i.id === v)
            .children || [];
        if (this.formOptions._invoiceItems.length) {
          this.formValues._invoiceItemId = this.formOptions._invoiceItems[0].id;
        } else {
          this.formValues._invoiceItemId = '';
        }
      },
      deep: true
    },
    step: {
      handler: function(v, oldV) {
        if (oldV === 1 && v === 0) {
          if (this.tableSelection && this.tableSelection.length) {
            this.$nextTick(() => {
              const p = {
                superKeys: this.tableSelection.map(i => ({
                  csoCustomOrderId: i.csoCustomOrderId
                })),
                useSeachInit: false
              };
              this.$refs['tableRender'].selectAllByRowKey(p);
            });
          }
        }
      }
    }
  },
  methods: {
    beforeInitPage0({ respond }) {
      respond.list.forEach(item => {
        if (item.orderNo in this.selectedPersonForOrderNo) {
          item['$selectedPerson'] = this.selectedPersonForOrderNo[item.orderNo];
        }
      });
      return respond;
    },
    toOpen() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      const taxationIdList = this.tableSelectionStep0.map(i => {
        return i.$selectedPerson.map(i => i.taxationId);
      });
      const invoiceItem = this.formOptions._invoiceItems.find(
        i => i.id === this.formValues._invoiceItemId
      );
      const q = {
        taxationIdList: flat(taxationIdList), //  数组

        invoiceCategory: this.formValues._invoiceCategoryId, //  通用的一级类目  id

        invoiceItemId: this.formValues._invoiceItemId, //     通用的二级类目  id

        id: this.formAddressSelected.id, //  地址id

        itemName: invoiceItem.itemName
      }; //   通用的二级类目名称

      const requestInvoiceSaveList =
        this.$refs.conentList &&
        this.$refs.conentList.$refs.tableRender.tableResp.list;

      const isChangeList =
        requestInvoiceSaveList &&
        requestInvoiceSaveList.filter(i => i.$isChange);

      const saveList =
        isChangeList &&
        isChangeList.map(i => ({
          userId: i.userId,
          invoiceCategory: i.invoiceCategory, //一级类目id
          invoiceItemId: i.invoiceItemId, //二级类目id
          itemName: i.itemName //二级类目名称
        }));

      invoice
        .submitToSave({
          ...q,
          requestInvoiceSaveList: saveList || []
        })
        .then(res => {
          const {
            data: { status, data: resInfo }
          } = res;
          if (+status === 1) {
            loading.close();
            createExtend(ApplyForCommissionSubmitRespond, {
              resInfo: resInfo
            });
            this.close();
          } else {
            loading.close();
          }
        })
        .catch(() => {
          loading.close();
        });
    },
    addressChange(addressId, addressList) {
      const currentSelected = addressList.find(i => i.id === addressId);
      currentSelected &&
        (this.formAddressSelected = addressList.find(i => i.id === addressId));
    },
    close() {
      this.$emit('close');
      this.remove();
    },
    submit() {
      this.$emit('submit');
      this.remove();
    },
    _initTableData() {
      // invoice.invoiceOpenListToBeOpened().then(res=>{
      // })
    },
    clearTableSelection() {
      this.$refs['tableRender'].clearTableSelection();
    }
  },
  created() {
    invoice.HarvestAddress().then(res => {
      const {
        data: { data }
      } = res;
      const { addressList, defaultInvoicingTypeList } = data;
      // const types = data.defaultInvoicingTypeList;
      this.formOptions = JSON.parse(JSON.stringify(data));

      // 选择默认地址
      const defaultAddress = addressList.find(i => +i.isDefault === 1) || {};
      this.addressChange(defaultAddress.id, addressList);
      this.formValues.addressId = defaultAddress.id;

      // 选择默认 开票类别
      const defaultCategory = defaultInvoicingTypeList.find(i => +i.id === 1);
      defaultCategory &&
        (this.formValues._invoiceCategoryId = defaultCategory.id);

      // 选择默认 发票类目d
      // this.formOptions._invoiceItems = defaultCategory.children;
      // defaultCategory.children.length && (this.formValues.invoiceItemId = defaultCategory.children[0]);
    });
  }
};
</script>
<style scoped>
.app-form-item {
  display: inline-flex;
  align-items: center;
  text-align: left;
  /*flex-wrap: wrap;*/
}

.app-form-label {
  display: inline-block;
  min-width: 130px;
  text-align: right;
  margin-right: 8px;
}

.app-form-input {
  flex: 1;
}
</style>
